import { render, staticRenderFns } from "./OrderListReturning.vue?vue&type=template&id=c72059c0&scoped=true"
import script from "./OrderListReturning.vue?vue&type=script&lang=js"
export * from "./OrderListReturning.vue?vue&type=script&lang=js"
import style0 from "./OrderListReturning.vue?vue&type=style&index=0&id=c72059c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72059c0",
  null
  
)

export default component.exports